import React from 'react';
import c from 'classnames';
import UserLink from '../../../User/Link';
import JoinGroupButton from '../../../JoinGroupButton';
import s from './GroupDetail.scss';
var GroupDetail = function (_a) {
    var group = _a.group, className = _a.className;
    if (!group) {
        return null;
    }
    return (React.createElement("div", { className: c(className) },
        React.createElement(UserLink, { className: s['username'], usernameClassName: s['username-inner'], withTooltip: true, user: group }),
        React.createElement(JoinGroupButton, { group: group })));
};
GroupDetail.displayName = 'GroupDetail';
export default GroupDetail;
//# sourceMappingURL=GroupDetail.js.map